"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundaryWidgetComponent = void 0;
const react_1 = __importDefault(require("react"));
const fallbacks_1 = require("../fallbacks");
const traceId = '866f372d-41b9-4bfe-b3fd-589596de1753';
const formatError = (url, scope, error) => ({
    url,
    scope,
    message: (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.stack) || '',
    traceId
});
class ErrorBoundaryWidgetComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        var _a;
        const { scope, url } = this.props;
        this.setState({ error });
        if ((_a = window === null || window === void 0 ? void 0 : window.sharedHostGateway) === null || _a === void 0 ? void 0 : _a.logger) {
            window.sharedHostGateway.logger.error(String(error), {
                stack: error.stack,
                message: error.message,
                tags: {
                    origin: window.location.origin,
                    environment: process.env.NODE_ENV,
                    scope,
                    url
                }
            });
        }
    }
    render() {
        const { error } = this.state;
        const { scope, url, children } = this.props;
        if (error) {
            return (react_1.default.createElement(fallbacks_1.ErrorFallbackCopyClipboard, { title: "Something went wrong.", error: formatError(url, scope, error) }));
        }
        return children;
    }
}
exports.ErrorBoundaryWidgetComponent = ErrorBoundaryWidgetComponent;
